import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import { View, Text } from '../../../Base';
import { WarningIcon } from '../../../icons';
import BaseCard from './BaseCard';
import Loading from './Loading';
import TotalDataRow from './TotalDataRow';

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '0.313rem',
    justifyContent: 'space-between',
  },
  text: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: 'white',
    flexDirection: 'row',
    display: 'flex',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  iconDefault: {
    width: '0.75rem',
    height: '0.75rem',
    lineHeight: '1rem',

    '& svg': {
      width: '0.75rem',
      height: '0.75rem',
    },
  },
  percentageText: {
    marginLeft: '0.313rem',
  },
  bold: {
    fontWeight: 'bold',
  },
}));

const CompactCard = ({
  route,
  spot,
  active,
  onDoubleClick,
  onClick,
  onRouteCodeClick,
}) => {
  const styles = useStyles();
  const totalExceptions =
    route.postcodeExceptions +
    route.serviceExceptions +
    route.dutyTimeExceptions +
    route.legalDutyExceptions +
    route.rangeExceptions;

  return (
    <BaseCard
      route={route}
      spot={spot}
      active={active}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onRouteCodeClick={onRouteCodeClick}
    >
      <View>
        <TotalDataRow route={route} />

        <View className={styles.row}>
          <View className={styles.textContainer}>
            <Text
              className={clsx(styles.text, styles.bold)}
              data-testid="total-exceptions"
            >
              Total Exceptions
            </Text>
            <Text
              className={clsx(styles.text, styles.percentageText)}
              data-testid="total-exceptions-value"
            >
              {totalExceptions}
            </Text>
            <View className={styles.iconDefault}>
              {!!totalExceptions && (
                <WarningIcon data-testid="total-exceptions-icon-warning" />
              )}
            </View>
          </View>
          <Loading
            routeStatusDescription={route.routeStatusDescription}
            loadingPercentage={route.loadingPercentage}
            lowLoadRate={route.lowLoadRate}
            routeStatus={route.routeStatus}
          />
        </View>
      </View>
    </BaseCard>
  );
};

export default memo(CompactCard);
